import React from "react";

import VenueLogos1 from "../../assets/venue-logos-1.png";
import VenueLogos2 from "../../assets/venue-logos-2.png";
import VenueLogos3 from "../../assets/venue-logos-3.png";

import VenueLogos4 from "../../assets/venue-logos-5.png";
import VenueLogos5 from "../../assets/venue-logos-4.png";

export default function PartnersSection() {
  return (
    <>
      <section className="md:hidden flex flex-col gap-[24px] bg-[#0B0415D9] mt-[48px] p-[20px_16px] border border-[#292433] rounded-[16px]">
        <img src={VenueLogos1} className="w-full h-auto" alt="venue-logos-1" />
        <div className="flex flex-col items-center gap-[12px] w-full text-center">
          <div className="bg-[#C9A6F540] p-[6px] rounded-[4px] font-semibold text-[#C9A6F5] text-[12px] uppercase">
            ONZE PARTNERS
          </div>
          <div className="font-normal text-[#F7F2FD] text-[22px] leading-[26px]">
            Wereldwijd bouwen we met de beste clubs, events en brands
          </div>
        </div>
        <img src={VenueLogos2} className="w-full h-auto" alt="venue-logos-2" />
        <img src={VenueLogos3} className="w-full h-auto" alt="venue-logos-3" />
      </section>

      <section className="max-md:hidden flex justify-between items-center gap-[24px] bg-[#0B0415D9] p-[64px_40px] border border-[#292433] rounded-[16px]">
        <img
          src={VenueLogos4}
          className="w-[324px] h-auto"
          alt="venue-logos-4"
        />
        <div className="flex flex-col items-center gap-[12px] w-full text-center">
          <div className="bg-[#C9A6F540] p-[6px] rounded-[4px] font-semibold text-[#C9A6F5] text-[12px] uppercase">
            ONZE PARTNERS
          </div>
          <div className="font-normal text-[#F7F2FD] text-[36px] leading-[40px] tracking-[-0.5px]">
            Wereldwijd bouwen we met de beste clubs, events en brands
          </div>
        </div>
        <img
          src={VenueLogos5}
          className="w-[324px] h-auto"
          alt="venue-logos-5"
        />
      </section>
    </>
  );
}
